/**
 * Path é o caminho da navegação excluindo o domínio sempre começando com barra.
 * Pode conter também a query e o hash
 * Caso seja a pena o path nunca terminará em barra
 * Ex: /promocoes
 * Ex: /promocoes/controle-orçamentario
 * Ex: /promocoes/controle-orcamentario?algo=1
 * Ex: /promocoes/controle-orcamentario?algo=1#algumhash
 * Ex: /promocoes/controle-orcamentario#algumhash
 *
 * Obs:
 *  - path se comporta como pathname do objeto window.location
 *  - query e hash se comportam como as propriedades de mesmo nome do objeto window.location
 */
type Path = `/${string}`;

/**
 * Href é o ${protocolo}//${hostname}. O protocolo aceito é somente o https
 * Protocolo e hostname se comportam como as propriedades de mesmo nome do objeto window.location
 */
type Href = `https://${string}`;

/**
 * Href é o ${protocolo}//${hostname}. O protocolo aceito é somente o http
 * Protocolo e hostname se comportam como as propriedades de mesmo nome do objeto window.location
 */
type HrefUnsafe = `http://${string}`;

/**
 * Remove barras duplicadas cuidando para não alterar as barras de protocolo https:// e http://
 * Remove a última barra caso exista
 * Não irá dar nenhum warning ou exception caso o parametro dirtHref não seja um endereço http
 *
 * @param dirtHref Endereço a ser tratado iniciando com 'https://' ou 'http://'
 * @returns Endereço tratado sem repetição de barras e sem a última barra caso exista
 */
const sanitizeHrefSlashes = (dirtHref: string): Href => {
  const protocolExec = /(https?:\/\/).+/g.exec(dirtHref);
  let clean = dirtHref.replace(/https?:\/\//g, ''); // Remove o protocolo
  clean = clean.replace(/\/$/, ''); // Remove a ultima barra
  clean = clean.replace(/\/{2,}/g, '/'); // Remove barras duplicadas
  return (protocolExec != null ? `${protocolExec[1]}${clean}` : clean) as Href;
};

/**
 * Remove barras duplicadas sempre mantendo ou adicionando a primeira e removendo a última caso não seja o único caracter
 * @param dirtHref Endereço a ser tratato
 * @returns Endereço tratado sem repetição de barras e sem a última barra caso ela seja o último caracter porém não único
 */
const sanitizePathSlashes = (dirtPath: string): Path => {
  let clean = dirtPath.replace(/\/{2,}/g, '/').replace(/\/$/, '');
  if (clean === '/') {
    return clean;
  }
  if (clean.endsWith('/')) {
    clean = clean.substring(0, clean.length - 1);
  }
  if (clean.startsWith('/')) {
    clean = clean.substring(1);
  }
  return `/${clean}`;
};

export { Path, Href, HrefUnsafe };
export { sanitizeHrefSlashes, sanitizePathSlashes };
